var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-progress-linear',{attrs:{"striped":_vm.striped,"value":_vm.progress,"height":_vm.height,"rounded":"","color":_vm.color},scopedSlots:_vm._u([{key:"default",fn:function({ value }){return [_c('strong',[_vm._v(_vm._s(Math.ceil(value))+"%")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }